import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router";

import { routes } from "routes/routes";

const Register: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const from = location.state?.from;

  useEffect(() => {
    navigate(routes.auth, { replace: true, state: { from } });
  }, [navigate, from]);

  return <></>;
};

export default Register;
